import * as $ from 'jquery';
import * as _ from 'underscore';

import { IGlob } from '../../../../_common/application/ts/Glob';
import BaseStore from '../../../../_common/platform/ts/BaseStore';
import { Constants } from './Constants';
import { apiCall } from '../../../../_common/platform/ts/AqlUtility';

import { Dispatcher } from './Dispatcher';
import { Action, Actions, I, check as checkAction } from './Actions';
import { config } from '../../../../pdc-platform/src/ts/config';
import { IMarkedItems } from '../../../../pdc-platform/src/ts/Interfaces';

export interface IRMState {
    data: IRMInstances;
}

export interface IRMInstances {
    [instanceId: string]: IRMInstanceState;
}

export interface IRMInstanceState {
    resourceTreeRootDirId: number;
    dataResponse: any;
    createResponse: any;
    loading: boolean;
    resourceData: any;
    dirContent: any;
    selectedDirId: number;
    selectedResources: IMarkedItems;
    dirInstanceId: string;
    resourceRenaming: number | string;
    resourceMoving: boolean;
    loadingImage: boolean;
}

export class Store extends BaseStore<IRMState, Actions, Dispatcher, IGlob> {
    public static _name = 'resource-manager';

    public static getInitialState() {
        var data: IRMInstances = {};

        return {
            data: data
        };
    }

    public static getInitialInstanceState(id): IRMInstanceState {
        return {
            resourceTreeRootDirId: -1,
            dataResponse: null,
            createResponse: null,
            loading: false,
            resourceData: null,
            dirContent: null,
            selectedDirId: -1,
            selectedResources: {},
            dirInstanceId: '',
            resourceRenaming: -1,
            resourceMoving: false,
            loadingImage: false
        };
    }

    public _state: IRMState;

    public getInstanceState(id) {
        var state = this._state.data[id];

        if (state == null) {
            state = this._state.data[id] = Store.getInitialInstanceState(id);
        }

        return state;
    }

    private getResourceTreeRoot = (instanceId) => {
        apiCall(this.glob.AppActions, 'resource_GetRootDir', {}).done((resp) => {
            this.actions.getResourceTreeRootFinish(instanceId, resp.result);
        });
    };

    private getResourceTreeRootFinish(instanceId, resp) {
        var instanceState = this.getInstanceState(instanceId);

        if (resp != null) {
            instanceState.resourceTreeRootDirId = resp.dirid;
            instanceState.selectedDirId = resp.dirid;
            this.getDirContent(instanceId, resp.dirid);
        }
    }

    private zeroFlags = (instanceId) => {
        var instanceState = this.getInstanceState(instanceId);
        instanceState.loadingImage = false;
    };

    private getData = (instanceId, resid) => {
        var instanceState = this.getInstanceState(instanceId);

        if (instanceState.loadingImage) {
            return;
        }

        instanceState.loadingImage = true;

        apiCall(this.glob.AppActions, 'resource_GetData', {
            resid: resid
        })
            .done((resp) => {
                this.actions.getDataFinish(instanceId, resp.result);
            })
            .fail((obj) => {
                this.actions.getDataFinish(instanceId, null);
            });
    };

    private getDataFinish(instanceId, resp) {
        var instanceState = this.getInstanceState(instanceId);
        instanceState.loadingImage = false;
        instanceState.resourceData = resp;
    }

    private loadFromFile = (instanceId, file) => {
        var instanceState = this.getInstanceState(instanceId);

        if (instanceState.loadingImage) {
            return;
        }

        instanceState.loadingImage = true;

        var reader = new FileReader();

        var self = this;

        reader.onloadend = function (event: any) {
            let originalData = event.target.result;
            var error = event.target.error;
            if (error != null) {
                self.glob.AppActions.notification('fail', 'File upload error ' + error.code.toString());
                self.actions.loadFromFileFinish(instanceId, null);
            }

            var regex = /^data\:([^\;]+)\;base64,(.+)$/;
            var matches = originalData.match(regex);
            var mimetype = matches[1];
            var data = matches[2];

            self.actions.getDataFinish(instanceId, {
                mimetype: mimetype,
                data: data
            });
        };

        reader.readAsDataURL(file);
    };

    private getDirContent = (instanceId, dirid) => {
        var instanceState = this.getInstanceState(instanceId);

        instanceState.selectedDirId = dirid;

        apiCall(this.glob.AppActions, 'resource_GetDirContent', {
            dirid: dirid
        })
            .done((resp) => {
                this.actions.getDirContentFinish(instanceId, resp.result);
            })
            .fail((obj) => {
                this.actions.getDirContentFinish(instanceId, null);
            });
    };

    private getDirContentFinish(instanceId, resp) {
        var instanceState = this.getInstanceState(instanceId);

        instanceState.resourceData = null;

        if (resp != null) {
            instanceState.dirContent = resp;
        }
    }

    private create = (instanceId, dirid, name, mimetype, data) => {
        apiCall(this.glob.AppActions, 'resource_Create', {
            dirid: dirid,
            name: name
        })
            .done((resp) => {
                var result = resp.result;

                if (result != null) {
                    this.actions.createFinish(instanceId, result, mimetype, data);
                    return;
                }
            })
            .fail((obj) => {
                this.actions.createFinish(instanceId, null, null, null);
            });
    };

    private delete(instanceId, dirid, resourceIDs: string[]) {
        _.map(resourceIDs, (resid, i) => {
            apiCall(this.glob.AppActions, 'resource_Delete', {
                resid: resid
            }).done(() => {
                this.actions.getDirContent(instanceId, dirid);
                this.setSelectedResource(instanceId, {});
            });
        });
    }

    private uploadData = (instanceId, dirid, resourceID: string, mimetype, data) => {
        apiCall(this.glob.AppActions, 'resource_UploadData', {
            resid: resourceID,
            mimetype: mimetype,
            data: data
        })
            .done((resp) => {
                this.actions.uploadDataFinish(instanceId, dirid, true);
                return;
            })
            .fail((obj) => {
                this.actions.uploadDataFinish(instanceId, null, false);
            });
    };

    private uploadDataFinish(instanceId, dirid, response) {
        var instanceState = this.getInstanceState(instanceId);

        instanceState.dataResponse = response;
        this.getDirContent(instanceId, dirid);
    }

    private createFinish(instanceId, response, mimetype, data) {
        var instanceState = this.getInstanceState(instanceId);

        if (response != null) {
            this.uploadData(instanceId, response.dirid, response.resid, mimetype, data);
            instanceState.createResponse = response;
        } else {
            instanceState.createResponse = false;
        }
    }

    private resourceRenameStart(instanceId, resourceID: string) {
        const instanceState = this.getInstanceState(instanceId);

        instanceState.resourceRenaming = resourceID;
    }

    private resourceRenameFinish(instanceId, resourceID: string, newName: string) {
        const instanceState = this.getInstanceState(instanceId);

        instanceState.resourceRenaming = -1;
        apiCall(this.glob.AppActions, 'resource_Rename', {
            resid: resourceID,
            name: newName
        }).done(() => {
            this.actions.getDirContent(instanceId, instanceState.selectedDirId);
        });
    }

    private resourceMoveCopyStart = (method, instanceId, resourceIDs: string[], toDirId) => {
        const instanceState = this.getInstanceState(instanceId);

        if (instanceState.selectedDirId === toDirId) {
            return false;
        }

        if (instanceState.resourceMoving) {
            return;
        }

        instanceState.resourceMoving = true;
        _.map(resourceIDs, (resid, i) => {
            apiCall(this.glob.AppActions, method, {
                resid: resid,
                dirid: toDirId
            }).always(() => {
                this.actions.resourceMoveFinish(instanceId);
            });
        });
    };

    private resourceMoveCopyFinish = (instanceId) => {
        const instanceState = this.getInstanceState(instanceId);

        instanceState.resourceMoving = false;
        this.actions.getDirContent(instanceId, instanceState.selectedDirId);
        this.setSelectedResource(instanceId, {});
    };

    private setSelectedResource(instanceId, selectedResources: IMarkedItems) {
        const instanceState = this.getInstanceState(instanceId);

        instanceState.selectedResources = selectedResources;
    }

    public getSelectedDir(instanceId) {
        const instanceState = this.getInstanceState(instanceId);
        const dirInstanceId = 'resource-tree-' + instanceState.resourceTreeRootDirId;
        const dirInstanceState = window['pdc'].platform.glob.DirsStore.getInstanceState(dirInstanceId);

        return dirInstanceState.data.dirsHash[instanceState.selectedDirId];
    }

    public getSelectedResources(instanceId) {
        const instanceState = this.getInstanceState(instanceId);
        const resources = _.filter(instanceState.dirContent, (obj) => {
            return instanceState.selectedResources[obj.resid] != null;
        });

        const apiEndpoint = config.getAPIEndpoint();
        const path = ['Resources'];
        const result = [];

        for (let index = 0; index < resources.length; index++) {
            const res = resources[index];
            const resource = {
                url: apiEndpoint + '/' + path.join('/') + '/' + (res.resid || 'undef'),
                res
            };

            result.push(resource);
        }

        return result;
    }

    public getFirstSelectedResource(instanceId) {
        const instanceState = this.getInstanceState(instanceId);

        const res = _.find(instanceState.dirContent, (obj) => {
            return instanceState.selectedResources[obj.resid] != null;
        });

        const apiEndpoint = config.getAPIEndpoint();
        const path = ['Resources'];

        return {
            url: apiEndpoint + '/' + path.join('/') + '/' + (res.resid || 'undef'),
            res
        };
    }

    // Upload binary resourse via POST request
    public postUpload(
        fileInput,
        editMode: boolean,
        instanceId,
        customName: string,
        selectedDirId,
        resourceID,
        name: string
    ) {
        const files = fileInput.files;

        if (editMode) {
            this.resourceRenameFinish(instanceId, resourceID, name);
        }

        if (files == null || files.length == 0) {
            return;
        } else {
            const formData = new FormData();
            const xhr = new XMLHttpRequest();

            name = customName !== '' ? customName : files[0].name;
            formData.append('fileInput', files[0], name);
            formData.append('dirid', selectedDirId);
            formData.append('name', name);
            formData.append('operation', editMode ? 'edit' : 'create');
            formData.append('resid', resourceID);

            const def = $.Deferred();
            const self = this;

            xhr.onreadystatechange = function () {
                if (this.readyState === 4) {
                    switch (this.status) {
                        case 200:
                            self.getDirContent(instanceId, selectedDirId);
                            break;
                        case 403:
                            self.glob.AppActions.showNotification_Fail(
                                'You have not enough permissions to upload to this folder'
                            );
                            break;
                        default:
                            self.glob.AppActions.showNotification_Fail(
                                'Error during file upload. Status code: ' + this.status
                            );
                            break;
                    }
                    def.resolve();
                }
            };

            const apiEndpoint = config.getAPIEndpoint();
            const postUploadfUrl = apiEndpoint + '/resources/upload';

            xhr.open('POST', postUploadfUrl);
            //VR: does not work for Russian Windows: const formBoundary = '-----PDCFormBoundary' + btoa((new Date().toString()));
            const formBoundary = '-----PDCFormBoundary' + btoa(new Date().getTime().toString());

            xhr.setRequestHeader('Content-type', 'multipart/form-data; charset=UTF-8; boundary=' + formBoundary);

            const authClause = 'Bearer ' + this.glob.userToken;

            xhr.setRequestHeader('Authorization', authClause);
            xhr.responseType = 'blob';
            xhr.send(formData);

            this.glob.AppActions.showNotification_Success('File ' + name + ' is being uploaded, please wait.', null, {
                progress: true,
                deferred: def
            });
        }
    }

    // VR: For Import: Upload binary resourse via POST request
    public postUploadOne(fileInput, guidString: string, def: JQueryDeferred<any>) {
        if (fileInput == null) {
            def.resolve();
        } else {
            const formData = new FormData();
            const xhr = new XMLHttpRequest();

            formData.append('fileInput', fileInput, guidString);
            formData.append('file', guidString);
            formData.append('operation', 'save');
            formData.append('resid', '-100');
            formData.append('name', guidString);
            formData.append('dirid', '-500');

            const self = this;

            xhr.onreadystatechange = function () {
                if (this.readyState === 4) {
                    switch (this.status) {
                        case 200:
                            self.glob.AppActions.showNotification_Success('Resource file is uploaded to server');
                            break;
                        default:
                            self.glob.AppActions.showNotification_Fail(
                                'Error during file upload. Status code: ' + this.status
                            );
                            break;
                    }
                    def.resolve();
                    formData.delete(guidString); // VR: must delete this BLOB ref.
                }
            };

            const apiEndpoint = config.getAPIEndpoint();
            const postUploadfUrl = apiEndpoint + '/resources/upload';

            xhr.open('POST', postUploadfUrl);

            //VR: does not work for Russian Windows: const formBoundary = '-----PDCFormBoundary' + btoa((new Date().toString()));
            const formBoundary = '-----PDCFormBoundary' + btoa(new Date().getTime().toString());

            xhr.setRequestHeader('Content-type', 'multipart/form-data; charset=UTF-8; boundary=' + formBoundary);

            const authClause = 'Bearer ' + this.glob.userToken;

            xhr.setRequestHeader('Authorization', authClause);
            xhr.responseType = 'blob';
            xhr.send(formData);

            this.glob.AppActions.showNotification_Success('Resource File is being uploaded, please wait.', null, {
                progress: true,
                deferred: def
            });
        }
    }

    protected eventsHandler(payload) {
        if (!super.eventsHandler(payload)) {
            return false;
        }

        const action = payload.action;

        switch (action.actionType) {
            case Constants.GET_DIR_CONTENT_FINISH:
                this.emitChange(this.getDirContentFinish(action.instanceId, action.response));
                break;
            case Constants.GET_DIR_CONTENT:
                this.emitChange(this.getDirContent(action.instanceId, action.dirid));
                break;
            case Constants.GET_RESOURCE_TREE_ROOT:
                this.getResourceTreeRoot(action.instanceId);
                break;
            case Constants.GET_RESOURCE_TREE_ROOT_FINISH:
                this.emitChange(this.getResourceTreeRootFinish(action.instanceId, action.response));
                break;
            case Constants.GET_DATA:
                this.emitChange(this.getData(action.instanceId, action.resid));
                break;
            case Constants.ZERO_FLAGS:
                this.emitChange(this.zeroFlags(action.instanceId));
                break;
            case Constants.GET_DATA_FINISH:
                this.emitChange(this.getDataFinish(action.instanceId, action.response));
                break;
            case Constants.LOAD_FROM_FILE:
                this.emitChange(this.loadFromFile(action.instanceId, action.fileName));
                break;
            case Constants.CREATE:
                this.emitChange(
                    this.create(action.instanceId, action.dirid, action.name, action.mimetype, action.data)
                );
                break;
            case Constants.CREATE_FINISH:
                this.emitChange(this.createFinish(action.instanceId, action.response, action.mimetype, action.data));
                break;
            case Constants.UPLOAD_DATA:
                this.emitChange(
                    this.uploadData(action.instanceId, action.dirid, action.resourceID, action.mimetype, action.data)
                );
                break;
            case Constants.UPLOAD_DATA_FINISH:
                this.emitChange(this.uploadDataFinish(action.instanceId, action.dirid, action.response));
                break;
            case Constants.DELETE:
                this.emitChange(this.delete(action.instanceId, action.dirid, action.resourceIDs));
                break;

            case Constants.RESOURCE_RENAME_START:
                this.emitChange(this.resourceRenameStart(action.instanceId, action.resourceID));
                break;

            case Constants.RESOURCE_RENAME_FINISH:
                this.emitChange(this.resourceRenameFinish(action.instanceId, action.resourceID, action.newName));
                break;

            case Constants.RESOURCE_MOVE_START:
                this.emitChange(
                    this.resourceMoveCopyStart('resource_Move', action.instanceId, action.resourceIDs, action.toDirId)
                );
                break;
            case Constants.RESOURCE_MOVE_FINISH:
                this.emitChange(this.resourceMoveCopyFinish(action.instanceId));
                break;

            case Constants.RESOURCE_COPY_START:
                this.emitChange(
                    this.resourceMoveCopyStart('resource_Copy', action.instanceId, action.resourceIDs, action.toDirId)
                );
                break;

            case Constants.SET_RESOURCE_SELECTED:
                this.emitChange(this.setSelectedResource(action.instanceId, action.selectedResources));
                break;
        }
        return true;
    }

    constructor(glob, dispatcher: Dispatcher, actions: Actions) {
        super(glob, dispatcher, actions, Store._name, true);

        this._state = _.extend(Store.getInitialState(), this._state);
    }

    static get(glob, dispatcher: Dispatcher, actions: Actions) {
        return new Store(glob, dispatcher, actions);
    }
}
